import { Typography, Box, Link } from '@mui/material';
import * as AppUrls from '../../../common/AppUrls';

const DocsGettingStarted = () => {
  return (
    <Box>
      <Typography variant="h1" gutterBottom>
        Get Started
      </Typography>
      <Typography variant="body1" paragraph>
        To begin using ClassChronicle to create the Time Table(s), you need to
        register for an account:
      </Typography>
      <ul>
        <li>
          <Typography variant="body1">
            Visit the{' '}
            <Link
              href="/sign-up"
              sx={{ fontWeight: 'bold', textDecoration: 'underline' }}
            >
              Sign Up
            </Link>{' '}
            page.
          </Typography>
        </li>
        <li>
          <Typography variant="body1">Enter your email address.</Typography>
        </li>
        <li>
          <Typography variant="body1">
            Read and accept the Terms of Service and Privacy Policy documents.
          </Typography>
        </li>
        <li>
          <Typography variant="body1">
            Verify your email by entering the OTP sent to your registered email
            address.
          </Typography>
        </li>
        <li>
          <Typography variant="body1">
            Set your password, and provide the required details.
          </Typography>
        </li>
        <li>
          <Typography variant="body1">
            You will be redirected to the{' '}
            <Link
              href="/sign-in"
              sx={{ fontWeight: 'bold', textDecoration: 'underline' }}
            >
              Sign In
            </Link>{' '}
            page.
          </Typography>
        </li>
        <li>
          <Typography variant="body1">
            Log in using your credentials.
          </Typography>
        </li>
      </ul>

      <Typography variant="h2" gutterBottom>
        Setting Up Your Profile
      </Typography>
      <Typography variant="body1" paragraph>
        Once logged in, you should complete your profile settings. Navigate to
        the profile section and update:
      </Typography>
      <ul>
        <li>
          <Typography variant="body1">
            <strong>Institution Details:</strong> Name and location.
          </Typography>
        </li>
        {/* <li>
          <Typography variant="body1">
            <strong>Administrator Information:</strong> Your role, contact details, and profile picture.
          </Typography>
        </li> */}
      </ul>

      <Typography variant="h2" gutterBottom>
        Dashboard Overview
      </Typography>
      <Typography variant="body1" paragraph>
        After setting up your profile, you can go back to the{' '}
        <Link
          href={AppUrls.DASHBOARD_URL}
          sx={{ fontWeight: 'bold', textDecoration: 'underline' }}
        >
          dashboard
        </Link>
        . Here, you can:
      </Typography>
      <ul>
        <li>
          <Typography variant="body1">
            Add departments, classrooms, subjects, teachers, and students.
          </Typography>
        </li>
        <li>
          <Typography variant="body1">
            Configure timetable preferences.
          </Typography>
        </li>
        <li>
          <Typography variant="body1">Generate and view timetables.</Typography>
        </li>
      </ul>
    </Box>
  );
};

export default DocsGettingStarted;
